export default "__VITE_ASSET__lCvDx7aZ__"